import './InstructionHeader.scss';
import InstructionHeader from './InstructionHeader';

function InstructionHeaderAdapter(props: any) {

  return (
    <InstructionHeader 
      title={props.title}
      introTable={props.introTable}
      subTitle={props.subTitle || ''}
    />
  );
}

export default InstructionHeaderAdapter;
